import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import axios from "axios";
import { MyApi } from "../MyApi";

export default function BookYourTaxi() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    pickup: "",
    drop: "",
    car_type: "",
    date: ""
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Handle Change
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });

    // realtime error remove
    setErrors({ ...errors, [e.target.name]: "" });
  };

  // ✅ Validation
  const validate = () => {
    let newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email address";
    }

    if (!formData.car_type) {
      newErrors.car_type = "Please select car type";
    }

    if (!formData.mobile) {
      newErrors.mobile = "Mobile is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10 digit number";
    }

    if (!formData.pickup) {
      newErrors.pickup = "Pickup location required";
    }

    if (!formData.drop) {
      newErrors.drop = "Drop location required";
    }

    if (!formData.date) {
      newErrors.date = "Please select date";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    try {
      setLoading(true);
      setSuccess("");
      setError("");

      const res = await axios.post(
        MyApi.BASE_URL + MyApi.ENQUIRY_FORM_book,
        formData,
        {
          headers: { Authorization: MyApi.SECRET_KEY },
        }
      );

      if (res.data.status) {
        setSuccess("Booking submitted successfully!");
        setFormData({
          name: "",
          email: "",
          mobile: "",
          pickup: "",
          drop: "",
          car_type: "",
          date: ""
        });
        setErrors({});
      } else {
        setError(res.data.message || "Something went wrong");
      }

    } catch (err) {
      console.error(err);
      setError("Server error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="booking-section">
      <Container>

        <h5 className="text-warning"> ONLINE BOOKING</h5>
        <h1 className="text-white mb-4">Book Your Taxi Ride</h1>

        {success && <Alert variant="success">{success}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Row>

            {/* Name */}
            <Col md={4}>
              <Form.Control
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                isInvalid={!!errors.name} 
                className="custom-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Col>

            {/* Email */}
            <Col md={4}>
              <Form.Control
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
                className="custom-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Col>

            {/* Car Type */}
            <Col md={4}>
              <Form.Select
                name="car_type"
                value={formData.car_type}
                onChange={handleChange}
                isInvalid={!!errors.car_type}
                className="custom-input"
              >
                <option value="">Pick Car type</option>
                <option value="Swift Dzire">Swift Dzire</option>
                <option value="Honda City">Honda City</option>
                <option value="Innova Crysta">Innova Crysta</option>
                <option value="Ertiga">Ertiga</option>
                <option value="Etios">Etios</option>
                <option value="Tempo Traveller">Tempo Traveller</option>
                <option value="Urbania">Urbania</option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.car_type}
              </Form.Control.Feedback>
            </Col>

            {/* Mobile */}
            <Col md={4} className="mt-3">
              <Form.Control
                name="mobile"
                placeholder="Phone Number"
                value={formData.mobile}
                onChange={handleChange}
                isInvalid={!!errors.mobile}
                className="custom-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobile}
              </Form.Control.Feedback>
            </Col>

            {/* Pickup */}
            <Col md={4} className="mt-3">
              <Form.Control
                name="pickup"
                placeholder="Start Destination"
                value={formData.pickup}
                onChange={handleChange}
                isInvalid={!!errors.pickup}
                className="custom-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.pickup}
              </Form.Control.Feedback>
            </Col>

            {/* Drop */}
            <Col md={4} className="mt-3">
              <Form.Control
                name="drop"
                placeholder="End Destination"
                value={formData.drop}
                onChange={handleChange}
                isInvalid={!!errors.drop}
                className="custom-input"
              />
              <Form.Control.Feedback type="invalid">
                {errors.drop}
              </Form.Control.Feedback>
            </Col>

            {/* Date */}
            <Col md={4} className="mt-3">
  <Form.Control
    type="date"
    name="date"
    value={formData.date}
    onChange={handleChange}
    isInvalid={!!errors.date}
    min={new Date().toLocaleDateString("en-CA")} // ✅ past disable
    className="custom-input"
  />
  <Form.Control.Feedback type="invalid">
    {errors.date}
  </Form.Control.Feedback>
</Col>

            {/* Button */}
            <Col md={8} className="mt-3 d-flex align-items-center">
              <Button type="submit" className="book-btn w-100" disabled={loading}>
                {loading ? "Booking..." : "Book Your Taxi"}
              </Button>
            </Col>

          </Row>
        </Form>

      </Container>
    </div>
  );
}